// extracted by mini-css-extract-plugin
export var boxItems = "_2f-1";
export var boxItemsLg = "_2f-2";
export var button = "_2f-7";
export var buttonHoverless = "_2f-9";
export var buttonLg = "_2f-8";
export var filterGroupBox = "_2f-0";
export var icon = "_2f-3";
export var iconSecondary = "_2f-6";
export var iconWrapper = "_2f-4";
export var iconWrapperLg = "_2f-5";
export var truncatedLabel = "_2f-a";